<script>
  import { _ } from 'svelte-i18n';
  import {params, querystring, push} from 'svelte-spa-router';
  import { scrolledPublicationId } from '../pages/Newsline/store';

  const back = () => {
    $scrolledPublicationId = $params.publ_id;

    const queryParams = new URLSearchParams($querystring);
    const prevUrl = queryParams.get('prev_url');

    push(prevUrl || '/');
  }
</script>

<div>
  <div class="main">
  <button class="button__exit text-grey text-bold" on:click={back} type="button">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.77243 2.74351C8.40931 3.02726 7.9141 3.4268 7.3884 3.88846C6.86538 4.34778 6.29588 4.88281 5.79188 5.4374C5.3118 5.96567 4.8218 6.58622 4.51484 7.22918C4.49694 7.26523 4.48042 7.30225 4.46539 7.34018C4.36199 7.59712 4.34273 7.84009 4.34409 8.00016C4.34273 8.16023 4.36199 8.4032 4.46539 8.66014C4.48042 8.69807 4.49694 8.73509 4.51484 8.77114C4.8218 9.4141 5.3118 10.0346 5.79188 10.5629C6.29588 11.1175 6.86538 11.6525 7.3884 12.1119C7.9141 12.5735 8.40931 12.9731 8.77243 13.2568C9.0281 13.4566 9.28384 13.6886 9.57274 13.8379C10.2023 14.1632 10.9926 13.9898 11.4222 13.3992C11.8909 12.7547 11.7424 11.8291 11.0997 11.36C9.98092 10.5376 8.8877 9.62935 7.95206 8.59979C7.75149 8.37909 7.58581 8.17807 7.45429 8.00016C7.58581 7.82225 7.75149 7.62123 7.95206 7.40053C8.95984 6.29158 10.4978 5.09124 10.9633 4.74165C11.6373 4.23547 11.9627 3.34436 11.4222 2.60116C10.9614 1.96762 10.0863 1.81367 9.43903 2.2407C9.21233 2.40219 8.99171 2.57215 8.77243 2.74351Z" fill="#2B50ED"/>
    </svg>      
    <span class="text__button">{$_('Back')}</span>
  </button>
  </div>
</div>

<style>
  i {
    overflow: hidden;
  }

.main{
  position: fixed;
  z-index:999;
}

.button__exit {
  color: #2B50ED;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  background: #EFF1FD;
  border: none;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  grid-gap: 4px;
  padding: 6px 8px;
  cursor: pointer;
}

@media (max-width: 1200px){
  .main{
    margin: 0 203px 0 70px;
  } 
}
@media (min-width: 320px) and (max-width: 1000px) {
  .main{
    display: none;
    margin: 0 0 0 0;
  } 
}
</style>
